var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pre-line"},[_vm._v(_vm._s(_vm._f("profanity")(_vm.text)))])}
var staticRenderFns = []

export { render, staticRenderFns }